// extracted by mini-css-extract-plugin
export default {"content":"ConComp_content__knl1u","con_heading":"ConComp_con_heading__312oy"};